import React from 'react';
import {
	Typography, Grid, IconButton, Icon, AppBar, Tabs, Tab,
	Table, TableBody, TableCell, TableRow, TableHead, Button
} from '@material-ui/core';
import { Helmet } from 'react-helmet';
import LoadBox from '../../components/LazyBox';
import moment from 'moment';

//services
import CinemaAPI from '../../../services/api/Cinema';

export default class VerFilme extends React.Component {
	state = {
		filme: [],

		tab: 0,
		dia: null,

		loading: true,
	}
	refreshFilme = () => {
		const { id } = this.props.match.params;
		CinemaAPI.filme(id)
			.then(res => {
				res.json().then(res => {
					if (res.msg) {
						return;
					}
					this.setState({
						filme: res,
						loading: false,
					})
					return;
				})
			});
	}

	componentDidMount() {
		this.refreshFilme()
	}
	render() {
		const { filme, loading, tab, dia } = this.state;
		const { PUBLIC_URL } = process.env;
		const { pathname } = this.props.location;
		if (loading) { return <LoadBox loading={loading} height="50vh" /> }
		return (
			<div className="app_content_page" >
				<Helmet>
					<title>{`${filme.TITULO} - Cinema`}</title>
					<meta name="description" content={`${filme.SINOPSE.replace(/<(.|\n)*?>/g, '').substring(0, 120)}..`} />

					<meta property="og:locale" content="pt_BR" />
					<meta property="og:url" content={`${PUBLIC_URL}${pathname}`} />
					<meta property="og:title" content={filme.TITULO} />
					<meta property="og:site_name" content="Shopping Norte Sul" />
					<meta property="og:description" content={`${filme.SINOPSE.replace(/<(.|\n)*?>/g, '').substring(0, 120)}..`} />
					<meta property="og:image" content={filme.IMAGENS[0].URL} />
					<meta property="og:type" content="website" />
				</Helmet>
				<div className="app_content_page__title_body" >
					<div className="title_body__content" >
						<Typography variant="h5" >Informações do filme</Typography>
					</div>
				</div>
				<div className="pre_header" >
					<div className="pre_header__body" >
						<Grid container >
							<Grid item md={6} >
								<Typography variant="h5" >{filme.TITULO}</Typography>
								<Typography variant="subtitle1" className="publication_timing" gutterBottom >Publicado em: {moment(filme.DATACAD).format('DD [de] MMMM [de] YYYY')}</Typography>
							</Grid>
							<Grid item md={6} className="pre_header__buttons" >
								<IconButton>
									<Icon>share</Icon>
								</IconButton>
							</Grid>
						</Grid>
					</div>
				</div>
				<div className="app_content_page__row" >
					<Grid container spacing={32} >
						<Grid item md={3} xs={12} >
							<img width="100%" src={filme.IMAGENS[0].URL.replace('?format=jpg&width=154&height=246&mode=stretch', '')} alt={filme.TITULO} />
						</Grid>
						<Grid item md={9} xs={12} >
							<Typography variant="h6" gutterBottom className="title_event" >GÊNERO:</Typography>
							<div className="text_event" style={{ marginBottom: 20 }} >{filme.ESTILO}</div>
							<Typography variant="h6" gutterBottom className="title_event" >CLASSIFICAÇÃO:</Typography>
							<div className="text_event" style={{ marginBottom: 20 }} >{filme.IDADEJUSTI.length < 1 ? 'CLASSIFICAÇÃO LIVRE' : filme.IDADEJUSTI}</div>
							<Typography variant="h6" gutterBottom className="title_event" >DURAÇÃO:</Typography>
							<div className="text_event" style={{ marginBottom: 20 }} >{filme.DURACAO ? `${filme.DURACAO}min` : 'Indisponível'}</div>
							<Typography variant="h6" gutterBottom className="title_event" >SINOPSE:</Typography>
							<div className="text_event" style={{ marginBottom: 20 }} dangerouslySetInnerHTML={{ __html: filme.SINOPSE }} />
							<Typography variant="h6" gutterBottom className="title_event" >PROGRAMAÇÃO:</Typography>
						</Grid>
						<Grid container spacing={16} >
							<Grid item md={12} xs={12} >
								<AppBar position="static" elevation={0} color="inherit">
									<Tabs
										value={tab}
										onChange={(e, v) => this.setState({ tab: v })}
										indicatorColor="primary"
										textColor="primary"
										variant="scrollable"
										scrollButtons="on"
									>
										{RemoveDuplicate(filme.PROGRAMACAO_FILME).map((p, k) => <Tab key={k}
											onClick={() => this.setState({ dia: moment(p).format('YYYY-MM-DD') })}
											label={
												<div>
													<Typography variant="h6" >{moment(p).format('DD/MM/YYYY')}</Typography>
													<Typography variant="subtitle2" >{moment(p).format('dddd')}</Typography>
												</div>
											} />)}
									</Tabs>
								</AppBar>
								<div style={{width: '100%', overflowX: 'auto'}} >
									<Table>
										<TableHead>
											<TableRow>
												<TableCell>HORARIO DA SESSÃO</TableCell>
												<TableCell>TIPO</TableCell>
												<TableCell>SALA</TableCell>
												<TableCell>STATUS</TableCell>
												<TableCell>OPÇÕES</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{FilterProgramacao(dia, filme.PROGRAMACAO_FILME).map((s, k) => (
												<TableRow key={k}>
													<TableCell>{moment(s.DATASESSAO).format('HH:mm')}</TableCell>
													<TableCell>{TextTecnologia(s.TECNOLOGIAS)}</TableCell>
													<TableCell>{ClearString(s.CODSALA)}</TableCell>
													<TableCell>{s.STATUS}</TableCell>
													<TableCell>
														<Button target="_BLANK" disabled={s.STATUS !== 'VENDENDO'} variant="contained" color="primary" href={UrlBuy(s, filme.TITULO)} >Comprar</Button>
													</TableCell>
												</TableRow>
											))}
										</TableBody>
									</Table>
								</div>
							</Grid>
						</Grid>
					</Grid>
				</div>
			</div>
		);
	}
}


function RemoveDuplicate(array) {
	let datas = [];
	for (let prog of array) {
		const data = moment(prog.DATASESSAO).format('YYYY-MM-DD');
		datas.push(data);
	}
	return datas.filter((elem, pos, arr) => {
		return arr.indexOf(elem) === pos;
	});
}

function FilterProgramacao(data, programacao) {
	if (data === null) {
		let dia = moment(programacao[0].DATASESSAO).format('YYYY-MM-DD');
		return programacao.filter(p => moment(p.DATASESSAO).format('YYYY-MM-DD') === dia)
	} else {
		return programacao.filter(p => moment(p.DATASESSAO).format('YYYY-MM-DD') === data)
	}

}

function TextTecnologia(tipo) {
	switch (tipo) {
		case 'DUB':
			return 'DUBLADO';
		case 'LEG':
			return 'LEGENDADO';
		case 'NAC':
			return 'NACIONAL';
		case '3D;LEG':
			return '3D LEGENDADO';
		case '3D;DUB':
			return '3D DUBLADO';
		default:
			return 'INDISPONÍVEL';
	}
}

function ClearString(string) {
	return string.replace(/[^0-9]/g, '');
}

function UrlBuy(sessao, titulo) {
	// https://www.veloxtickets.com/Parceiro/P-CINEMAGIC/Ingressos/Cinema/vitoria/IT-Capitulo-2/Cinemagic-Vitoria/2019-09-16/11e9d3f5ef80390480bfd09a15f8b963
	let url = 'https://www.veloxtickets.com/Parceiro/P-CINEMAGIC/Ingressos/Cinema/Vitoria/R_TITULO/Cinemagic-Vitoria/R_DATA/R_IDPROG';
	url = url.replace('R_TITULO', removeAcento(titulo).replace(/[^A-Z0-9]+/ig, '-'))//TITULO
	url = url.replace('R_DATA', moment(sessao.DATASESSAO).format('YYYY-MM-DD'))//DATA
	url = url.replace('R_IDPROG', sessao.IDPROG);//HASH DA PROGRAMACAO
	return url;
}

function removeAcento(text) {
	// text = text.toLowerCase();
	text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
	text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
	text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
	text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
	text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
	text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
	return text;
}



// WEBPACK FOOTER //
// ./src/web/pages/cinema/filme.js